import { defineStore } from 'pinia';
import { reactive, toRefs } from 'vue';
import { cloneDeep } from 'lodash-es';

interface MainStoreState {
	isAppLoading: boolean;
	isMavenChatOpen: boolean;
}

export const useMainStore = defineStore('main', () => {
	const DEFAULT_STATE = {
		isAppLoading: false,
		isMavenChatOpen: false,
	};

	const state = reactive<MainStoreState>(cloneDeep(DEFAULT_STATE));

	const abortControllers = reactive<Record<string, AbortController>>({});

	function toggleMavenChat() {
		state.isMavenChatOpen = !state.isMavenChatOpen;
	}

	const $reset = () => {
		Object.assign(state, cloneDeep(DEFAULT_STATE));
	};

	return {
		...toRefs(state),
		abortControllers,
		$reset,
		toggleMavenChat,
	};
});
